import { WsSalesSolutionItem, WsSalesSolutionAction, WsSalesSolutionMetric, WsSalesSolutionAssumption, WsSalesSolutionDependency } from '../core';
import { WsSalesSolutionDeliverableClass, WsSalesSolutionOfferingRoleClass, WsSalesSolutionRiskClass, WsSalesSolutionToolClass, WsSalesSolutionWorkProductClass } from '../core-sales';
import { WsSalesSolutionActionFind, WsSalesSolutionItemFind, findItemById } from '../core/sales-actions';
import { padRight } from '../helpers-log';




export type WsFilterOptions = {
  filterSelectedCapabilities?: boolean;
  filterSelectedActions?:      boolean;
  includeChildCapabilities?:   boolean;
  includeChildActions?:        boolean;
};




const getValue = (currentValue: any, defaultValue: any) => {
  if (typeof currentValue === 'undefined' || currentValue === null) {
    return defaultValue;
  } else {
    return currentValue;
  }
};





const itemIsCapability = (item: WsSalesSolutionItem | WsSalesSolutionAction | undefined): item is WsSalesSolutionItem => {
  if (itemIsAction(item)) {
    return false;
  } else {
    return true;
  }
};


const itemIsAction = (item: WsSalesSolutionItem | WsSalesSolutionAction | undefined): item is WsSalesSolutionAction => {
  if (item) {
    return (item as WsSalesSolutionAction).hasOwnProperty('effort');
  } else {
    return false;
  }
};




const itemFindIsAction = (itemFind: WsSalesSolutionItemFind | WsSalesSolutionActionFind | undefined): itemFind is WsSalesSolutionActionFind => {
  if (itemFind) {
    return itemFind.hasOwnProperty('action');
  } else {
    return false;
  }
};




const getActionTreeFromItem = () => {
  return [];
};




const getActionListFromItem = () => {
  return [];
};




export type WsSalesItemChild =  WsSalesSolutionItem              |
                         WsSalesSolutionAction            |
                         WsSalesSolutionMetric            |
                         WsSalesSolutionDeliverableClass  |
                         WsSalesSolutionWorkProductClass  |
                         WsSalesSolutionOfferingRoleClass |
                         WsSalesSolutionToolClass         |
                         WsSalesSolutionRiskClass         |
                         WsSalesSolutionAssumption        |
                         WsSalesSolutionDependency;

const filterItemChildren = (item: WsSalesSolutionItem | WsSalesSolutionAction, type: string) => {
  let children: WsSalesItemChild[] = [];

  if (itemIsAction(item)) {
    // action

    if (type === 'actions') {
      children = item.actions || [];

    } else if (type === 'metrics') {
      children = item.metrics || [];

    } else if (type === 'deliverables') {
      children = item.children?.filter((child) => child instanceof WsSalesSolutionDeliverableClass) || [];

    } else if (type === 'workProducts') {
      children = item.children?.filter((child) => child instanceof WsSalesSolutionWorkProductClass) || [];

    } else if (type === 'roles') {
      children = item.children?.filter((child) => child instanceof WsSalesSolutionOfferingRoleClass) || [];

    } else if (type === 'tools') {
      children = item.children?.filter((child) => child instanceof WsSalesSolutionToolClass) || [];

    } else if (type === 'risks') {
      children = item.children?.filter((child) => child instanceof WsSalesSolutionRiskClass) || [];

    } else if (type === 'assumptions') {
      children = item.assumptions || [];

    } else if (type === 'dependencies') {
      children = item.dependencies || [];
    }

  } else {
    // item

    if (type === 'capabilities') {
      children = item.items || [];

    } else if (type === 'actions') {
      children = item.actions || [];
  
    } else if (type === 'assumptions') {
      children = item.assumptions || [];

    } else if (type === 'dependencies') {
      children = item.dependencies || [];
    }
  }

  return children;
};




const isTopLevel = (id: string) => {

  const ids = {
    '01H548HM2HA89VQTVKVCDJ2C3R': true,
    '01H4GTG96RG0D54NABN15GTFTB': true,
    '01H4GTG96R72GBPXJS0AA0VQN4': true,
    '01H4GTG96RDX8QTVHM3JE5JFTQ': true,
    '01H548KF2HR2D5MND0E01WRE09': true,
    '01H7YP9ABD1VPEPS42GQF10W87': true,
    '01H4GTG96RDZTAHKDXWN1JYM2F': true
  }

  const v = ids[id] ? true : false;

  return v
}

const getChildItems = (item: WsSalesSolutionItem | WsSalesSolutionAction, type: string, options: WsFilterOptions, path = '') => {

  const filterSelectedCapabilities = getValue(options.filterSelectedCapabilities, false);
  const filterSelectedActions      = getValue(options.filterSelectedActions,      false);
  const includeChildCapabilities   = getValue(options.includeChildCapabilities,   false);
  const includeChildActions        = getValue(options.includeChildActions,        false);



  let list: [ WsSalesItemChild, WsSalesSolutionItem | WsSalesSolutionAction, string ][] = []; // TODO: refactor any[]



  // item.children

  if (
    !itemIsAction(item) && (item.selected || !filterSelectedCapabilities)
    ||
    itemIsAction(item)  && (item.selected || !filterSelectedActions)
  ) {

    const itemChildren = filterItemChildren(item, type);

    if (itemChildren && Array.isArray(itemChildren) && itemChildren.length > 0) {

      const itemChildrenAndParent: [ WsSalesItemChild, WsSalesSolutionItem | WsSalesSolutionAction, string ][] = itemChildren.map((ic) => {
        return [ ic, item, path ];
      });

      list = list.concat(itemChildrenAndParent);
    }
  }



  // item

  if (itemIsAction(item)) {
    // action


    // action.actions

    if (includeChildActions) {
      if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {
        item.actions.forEach((i) => {
          list = list.concat(getChildItems(i, type, options, `${path}/${item.name}`));
        });
      }
    }



  } else {
    // capability


    // capability.actions

    if ((item.selected || !filterSelectedCapabilities)) {

      if (includeChildActions) {
        if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {
          item.actions.forEach((i) => {
            list = list.concat(getChildItems(i, type, options, `${path}/${item.name}`));
          });
        }
      }
    }


    // capability.items

    if (includeChildCapabilities) {

      if (item.items && Array.isArray(item.items) && item.items.length > 0) {
        item.items.forEach((i) => {
          list = list.concat(getChildItems(i, type, options, `${path}/${item.name}`));
        });
      }
    }

    // if (isAnyActionSelected(item)) {
    // actions
    // }

    // if (isAnyItemSelected(item)) {
    // items
    // }
  }



  // return

  return list;
};
















const getChildItemsFromTopLevelItems = (items: WsSalesSolutionItem[], type: string, options: WsFilterOptions) => {
  let list: [ WsSalesItemChild, WsSalesSolutionItem | WsSalesSolutionAction, string ][] = [];

  items.forEach((item) => {
    const i = getChildItems(item, type, options);
    list.push(...i); // list = list.concat(i);
  });

  return list;
};







const getMetricsFromTopLevelItems = (items: WsSalesSolutionItem[], options: { onlySelected: boolean }) => {

  let list: any[] = []; // TODO: refactor any[]

  items.forEach((i) => {
    list = list.concat(getAllMetricsByItem(i, options.onlySelected));
  });

  return list;
};










const getAllMetrics = (actions: WsSalesSolutionAction[], onlySelected?: boolean) => {

  let list: WsSalesSolutionMetric[] = [];

  actions.forEach((action) => {

    if ((onlySelected && action.selected) || !onlySelected) {
      if (action.metrics && action.metrics.length > 0) {
        action.metrics.forEach((metric) => {
          list.push(metric);
        });
      }
    }

    if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) {
      list = list.concat(getAllMetrics(action.actions, onlySelected));
    }
  });

  return list;
};




const getAllMetricsByItem = (item: WsSalesSolutionItem, onlySelected?: boolean) => {

  let list: WsSalesSolutionMetric[] = [];

  if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {
    if ((onlySelected && item.selected) || !onlySelected) {
      list = list.concat(getAllMetrics(item.actions, onlySelected));   
    }
  }

  if (item.items && Array.isArray(item.items) && item.items.length > 0) {
    item.items.forEach((i) => {
      list = list.concat(getAllMetricsByItem(i, onlySelected));
    });
  }

  return list;
};




const getMetricAction = (
  items: WsSalesSolutionItem[] | WsSalesSolutionAction[],
  metric: WsSalesSolutionMetric
): WsSalesSolutionAction | undefined => {

  let value: WsSalesSolutionAction | undefined = undefined;

  if (items) {
    // console.log('getMetricAction');

    items.forEach((item: WsSalesSolutionItem | WsSalesSolutionAction) => {

      if (itemIsAction(item)) {
        // action

      } else {
        // capability

        if (item.items && Array.isArray(item.items) && item.items.length > 0) {
          const v = getMetricAction(item.items, metric);
          if (v) {
            value = v;
          }
        }
      }

      // console.log(`1 : ${item.name}`);

      if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {
        // console.log('item.actions');

        item.actions.forEach((action) => {

          // console.log(`2 : ${action.name}`);

          if (action.actions) {

            const v = getMetricAction(action.actions, metric);
            if (v) {
              value = v;
            }

          } else {

            // console.log(`3 : ${action.name}`);

            if (action.metrics) {
              // console.log('4 :');

              action.metrics.forEach((m) => {
                // console.log(`5 : ${m.name}`);
                if (m.id === metric.id) {
                  value = action;
                }
              });
            }
          }
        });
      }
    });
  }

  return value;
};








const isAnyItemExpanded = (item: WsSalesSolutionItem) => {

  let value = false;

  if (item.items && Array.isArray(item.items) && item.items.length > 0) {

    item.items.forEach((i) => {
      const x = isAnyItemExpanded(i);
      if (x) {
        value = true;
      }
    });

  } else {

    if (item.expanded) {
      value = true;
    }
  }

  return value;
};




const isAnyItemSelected = (item: WsSalesSolutionItem): boolean => {

  let value: boolean = false;

  if (item.items && Array.isArray(item.items) && item.items.length > 0) {

    item.items.forEach((i) => {
      const x = isAnyItemSelected(i);
      if (x) {
        value = true;
      }
    });

  } else {

    if (item.selected) {
      value = true;
    }
  }

  return value;
};




const isAnyActionSelected = (item: WsSalesSolutionItem | WsSalesSolutionAction): boolean => {

  let value: boolean = false;

  if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {
    item.actions.forEach((action: WsSalesSolutionAction) => {
      const b = isAnyActionSelected(action);
      if (b) {
        value = true;
      }
    });
  }

  if (itemIsAction(item)) {
    if (item.selected) {
      value = true;
    }
  }

  return value;
};




const isAnyItemAndActionSelected = (item: WsSalesSolutionItem): boolean => {

  let value: boolean = false;

  // console.log(`===== ${padRight(item.name, 35)} =====`);



  if (item.items && Array.isArray(item.items) && item.items.length > 0) {
    item.items.forEach((i) => {
      const b = isAnyItemAndActionSelected(i);
      if (b) {
        value = true;
      }
    });
  }



  if (item.selected) {
    const b = isAnyActionSelected(item);
    if (b) {
      value = true;
    }
  }



  // console.log(`isAnyItemAndActionSelected : ${value}`);

  return value;
};




const isActionSelected = (action: WsSalesSolutionAction) => {

  if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) {

    let value = true;

    action.actions.forEach((a: WsSalesSolutionAction) => {
      if (!isActionSelected(a)) {
        value = false;
      }
    });

    return value;

  } else {
    return action.selected;
  }
};




const isActionNotSelected = (action: WsSalesSolutionAction) => {

  if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) {
 
    let value = true;

    action.actions.forEach((a: WsSalesSolutionAction) => {
      if (!isActionNotSelected(a)) {
        value = false;
      }
    });

    return value;

  } else {
    return !action.selected;
  }
};







const getItemExpanded = (item: WsSalesSolutionItem, mode: string) => {

  const itemExpanded = item.expanded; // isAnyItemExpanded(item);

  if (mode === 'scope') {

    if (itemExpanded) {
      return item.items && Array.isArray(item.items) && item.items.length > 0;

    } else {
      return false;
    }

  } else if (mode === 'size') {
    return true;

  } else if (mode === 'admin') {
    return itemExpanded;

  } else {
    return itemExpanded;
  }
};




const getActionExpanded = (action: WsSalesSolutionAction, mode: string) => {
  if (mode === 'admin') {
    // return true;
    return action.expanded;
  } else {
    return action.expanded;
  }
};







const setItemSelected = (selected: boolean, item: WsSalesSolutionItem, mode: string, items: WsSalesSolutionItem[], options: { selectChildCapabilities: boolean }) => {
  const links: WsSalesSolutionItemFind[] = [];

  // item

  item.selected = selected;


  // children

  if (options.selectChildCapabilities) {

    if (item.items && Array.isArray(item.items) && item.items.length > 0) {

      item.items.forEach((i: WsSalesSolutionItem) => {
        const x = setItemSelected(selected, i, mode, items, options);
        links.push(...x);
      });
    }
  }


  // links

  if (item.selected) {
  }

  if (item.linkIds && Array.isArray(item.linkIds) && item.linkIds.length > 0) {

    item.linkIds.forEach((linkId) => {

      const itemFind = findItemById(items, linkId, '', {});

      if (itemFind) {
        links.push(itemFind);

        const x = setItemSelected(selected, itemFind.item, mode, items, options);
        links.push(...x);
      }
    });
  }



  // return

  return links;
};







const setItemProperty = (currentItem: WsSalesSolutionItem, setProperty: (item: WsSalesSolutionItem) => void) => {

  setProperty(currentItem);

  if (currentItem.items && Array.isArray(currentItem.items) && currentItem.items.length > 0) {

    currentItem.items.forEach((item: WsSalesSolutionItem) => {
      setItemProperty(item, setProperty);
    });
  }
};




export {
  filterItemChildren,
  getChildItems,
  getActionTreeFromItem,
  getActionListFromItem,

  getChildItemsFromTopLevelItems,
  getMetricsFromTopLevelItems,

  getAllMetrics,
  getAllMetricsByItem,
  getMetricAction,

  isAnyItemExpanded,
  isAnyItemSelected,
  isAnyActionSelected,
  isAnyItemAndActionSelected,
  isActionSelected,
  isActionNotSelected,
  itemIsCapability,
  itemIsAction,
  itemFindIsAction,
  getValue,

  getItemExpanded,
  getActionExpanded,
  setItemSelected,
  setItemProperty
};
